<template>
    <div class="full-screen">
        <div class="operation-bar">
            <h1>发货单明细</h1>
            <div class="operation-bar-right">
                <a href="javascript:void(0)" @click="deleteSendDetail">删除</a>
<!--                <a href="javascript:void(0)" @click="printInvoice">打印发货单</a>-->
            </div>
        </div>
        <div style="height: calc(100% - 35px);width: 100%; overflow: hidden">
            <el-table :data="sendDetailList" height="100%" ref="table"
                      v-loading = "bottomLoading"
                      :header-cell-style="{background:'#4885CA', color: 'white'}">
                <el-table-column type="selection" width="55" align="center" header-align="center">
                </el-table-column>
                <el-table-column label="序号" type="index" width="55" align="center" header-align="center">
                </el-table-column>
                <el-table-column  width="110" property="order_no"  label="采购订单号" align="center" header-align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column  width="110" property="row_no"  label="采购行项目" align="center" header-align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{scope.row.row_no === '0'?'':scope.row.row_no}}</span>
                    </template>
                </el-table-column>
                <el-table-column  width="110" property="sap_invoice_no"  label="内向交货单号" align="center" header-align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column  width="110" property="sap_sale_order_no"  label="销售订单号" align="center" header-align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column  width="110" label="销售行项目" align="center" header-align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{scope.row.sap_sale_order_row_no === 0?'':scope.row.sap_sale_order_row_no}}</span>
                    </template>
                </el-table-column>
                <el-table-column  width="120" label="物料编码" align="center" header-align="center" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{scope.row.sap_mtrl_code.substr(-10,10)}}</span>
                    </template>
                </el-table-column>
                <el-table-column  width="260" property="sap_mtrl_name"  label="物料名称" align="center" header-align="center" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column width="180" property="comp_name"  label="采购方" align="center" header-align="center" :show-overflow-tooltip="true">
                </el-table-column>
<!--                <el-table-column property="expectDate" width="100" label="交货日期" align="center" header-align="center" >-->
<!--                </el-table-column>-->
                <el-table-column width="90" label="发货数量" align="center" header-align="center">
                    <template slot-scope="scope">
                        <span style="color: green; font-weight: bold">{{scope.row.qty}}</span>
                    </template>
                </el-table-column>
                <el-table-column property="uom" width="90" label="计量单位" align="center" header-align="center">
                </el-table-column>
                <el-table-column property="price" width="90" label="单价" align="center" header-align="center">
                </el-table-column>
                <el-table-column property="sap_tax_code" width="70" label="税码" align="center" header-align="center">
                </el-table-column>
                <el-table-column property="sap_tax_code_desc" width="120" label="税码描述" align="center" header-align="center" :show-overflow-tooltip="true">
                </el-table-column>
<!--                <el-table-column  width="150" property="vendorRemark" label="沟通备注" align="center" header-align="center" :show-overflow-tooltip="true">-->
<!--                </el-table-column>-->
<!--                <el-table-column property="vendorRemark" label="采购方备注" align="center" header-align="center" :show-overflow-tooltip="true">-->
<!--                </el-table-column>-->
            </el-table>
            </div>
    </div>
</template>
<script>
    export default {
        name: 'bottomTable',
        props: ['sendDetailList', 'isLock', 'bottomLoading'],
        methods: {
            deleteSendDetail() {
                if(this.$refs.table.selection.length > 0) {
                    this.$confirm('删除发货单明细, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'info'
                    }).then(() => {
                        if(!this.isLock){
                            let ids = [];
                            this.$refs.table.selection.forEach(item => {
                                ids.push(item.id);
                            });
                            this.$store.dispatch('send/send/deleteSendDetail', ids.join(',')).then((res)=>{
                                if(res.code === '200') {
                                    this.$emit('refreshData');
                                }else{
                                    this.$message.error(res.data?res.data : res.message);
                                }
                            })
                        }else{
                            this.$message.warning("当前发货单已提交，无法继续删除明细")
                        }
                    });
                }else{
                    if(!this.isLock){
                        this.$message.warning("请选择要删除的记录")
                    }
                }
            },
            printInvoice() {
                this.$emit("printInvoice");
            }
        }
    };
</script>
<style scoped>
</style>
